import React, { useState } from "react";
import { Modal, Button, Image, Col, Row, Form } from "react-bootstrap";
import { TextField, IconButton, FormControl, Select } from "@material-ui/core";
export const SuperAdminResetPassword = () => {
  //state
  const [showResetPassword, seShowResetPassword] = useState(false);
  const handleCloseResetPassword = () => seShowResetPassword(false);
  const handleShowResetPassword = () => seShowResetPassword(true);
  const [ShowPassword, setShowPassword] = useState({ ShowPassword: false });
  const [ShowPassword2, setShowPassword2] = useState({ ShowPassword2: false });
  const [resetPassword, seResetPassword] = useState(false);
  const handleResetPassword = () => {
    seResetPassword(true);
  };
  const [state, setState] = useState({
    code: "",
  });

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };
  const handleClickShowPassword = (e) => {
    setShowPassword({
      ShowPassword: !ShowPassword.ShowPassword,
    });
  };
  const handleClickShowPassword2 = (e) => {
    setShowPassword2({
      ShowPassword2: !ShowPassword2.ShowPassword2,
    });
  };
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowResetPassword}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/ResetDrive.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal
        show={showResetPassword}
        onHide={handleCloseResetPassword}
        centered
      >
        <Modal.Header className="py-0 pt-3 border-0" closeButton>
          <Modal.Title className="f16-500">Reset Password</Modal.Title>
        </Modal.Header>
        {!resetPassword && (
          <React.Fragment>
            <Modal.Body>
              <Row>
                <Col xs={4} className="pr-0">
                  <Form.Group controlId={"country_code"}>
                    <FormControl variant="outlined" className="w-100">
                      <Select
                        value={state.code}
                        onChange={handleChangeCode}
                        inputProps={{
                          name: "code",
                        }}
                      >
                        <option value={+91}>+91</option>
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col xs={8}>
                  <TextField
                    id="outlined-basic"
                    label="Phone Number"
                    variant="outlined"
                    className="w-100"
                  />
                </Col>
                <Col xs={12}>
                  <div className="py-4">
                    <span className="f14-400">Name:</span>
                    <span className="f14-500">New Sunshine Restaurant</span>
                  </div>
                </Col>
                <Col xs={12} className="pt-2">
                  <Form.Group>
                    <TextField
                      id="enPassword"
                      label="Enter New Password"
                      variant="outlined"
                      type={ShowPassword.ShowPassword ? "text" : "password"}
                      className="enPassword w-100"
                    />
                    <IconButton
                      className="enShowPasswordBtn"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {ShowPassword.ShowPassword ? (
                        <Image
                          src={require("../../../../assets/images/UserManagement/view--on.svg")}
                          alt="View"
                          width="20px"
                          title="View"
                          fluid
                        />
                      ) : (
                        <Image
                          src={require("../../../../assets/images/UserManagement/view--off.svg")}
                          alt="View"
                          width="20px"
                          title="View"
                          fluid
                        />
                      )}
                    </IconButton>
                  </Form.Group>
                </Col>
                <Col xs={12} className="pt-2">
                  <Form.Group>
                    <TextField
                      id="enPassword"
                      label="Confirm New Password"
                      variant="outlined"
                      type={ShowPassword2.ShowPassword2 ? "text" : "password"}
                      className="enPassword w-100"
                    />
                    <IconButton
                      className="enShowPasswordBtn"
                      onClick={handleClickShowPassword2}
                      edge="end"
                    >
                      {ShowPassword2.ShowPassword2 ? (
                        <Image
                          src={require("../../../../assets/images/UserManagement/view--on.svg")}
                          alt="View"
                          width="20px"
                          title="View"
                          fluid
                        />
                      ) : (
                        <Image
                          src={require("../../../../assets/images/UserManagement/view--off.svg")}
                          alt="View"
                          width="20px"
                          title="View"
                          fluid
                        />
                      )}
                    </IconButton>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-4"
                onClick={handleCloseResetPassword}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-4"
                onClick={handleResetPassword}
              >
                Submit
              </Button>
            </Modal.Footer>
          </React.Fragment>
        )}
        {resetPassword && (
          <Modal.Body>
            <Image
              src={require("../../../../assets/images/UserManagement/checked.svg")}
              alt="View"
              title="View"
              fluid
              className="enResetPaaswordChecked"
            />
            <div className="f17-500 mt-4 mb-2">
              Your password was successfully reset
            </div>
            <div className="f13-400 mb-4">
              An email and SMS was sent to the user about the password change
              and new password was sent
            </div>
            <Button
              variant="danger"
              className="btn-lg px-4"
              onClick={handleCloseResetPassword}
            >
              Okay
            </Button>
          </Modal.Body>
        )}
      </Modal>
    </React.Fragment>
  );
};
